var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg044DepartureCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.001,
    height: 512.001,
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.822 164.651c-43.376-16.015-89.984-18.441-134.788-7.019l-58.221 14.843-164.956-94.571a15.034 15.034 0 0 0-11.19-1.525L51.38 94.043a15.034 15.034 0 0 0-11.023 11.6 15.029 15.029 0 0 0 5.677 14.96l114.64 86.581-47.206 12.035-65.035-38.557c-6.867-4.071-15.721-2.063-20.16 4.575L2.536 223.73a15.03 15.03 0 0 0 1.586 18.694l77.814 82.1a15.03 15.03 0 0 0 14.623 4.226l389.895-99.399c14.7-3.748 24.709-15.96 25.497-31.11.789-15.151-7.897-28.335-22.129-33.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.918 406.026H15.031C6.73 406.026 0 412.756 0 421.057s6.73 15.031 15.031 15.031h243.886c8.301 0 15.031-6.73 15.031-15.031s-6.729-15.031-15.03-15.031z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg044DepartureCalendar);
export default __webpack_public_path__ + "static/media/044-departure-calendar.912bd1d1.svg";
export { ForwardRef as ReactComponent };